// eslint-disable-next-line import/no-commonjs
module.exports = require('./lib/builder').default
